import styled from '@emotion/styled';
import { fontSize } from 'src/assets/fonts-config';

export const ImageWrapper = styled('figure', { label: 'ImageWrapper' })`
    display: block;
    margin: 0;
`;

export const Image = styled('img', { label: 'Image' })`
    background-color: #878b96;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 120px;
    object-fit: fill;
    width: 100%;
`;

export const DeleteWrapper = styled('figcaption', { label: 'DeleteWrapper' })`
    color: red;
    cursor: pointer;
    display: inline-block;
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.xRegular};
    line-height: 1;
    overflow: hidden;
    position: relative;
    &::before {
        background: red;
        content: '';
        height: 1px;
        inset: calc(100% - 1px) auto auto -100%;
        position: absolute;
        transition: transform 0.2s ease;
        width: 100%;
    }
    &:hover {
        &::before {
            transform: translateX(100%);
        }
    }
`;
